var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockKeyhole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3a3.134 3.134 0 013.125 3.125V8h-6.25V6.125A3.11 3.11 0 018.75 3zM3.125 6.125V8H2.5A2.492 2.492 0 000 10.5V18c0 1.406 1.094 2.5 2.5 2.5H15c1.367 0 2.5-1.094 2.5-2.5v-7.5C17.5 9.133 16.367 8 15 8h-.625V6.125C14.375 3.039 11.835.5 8.75.5a5.626 5.626 0 00-5.625 5.625zM10 13v2.5c0 .703-.586 1.25-1.25 1.25-.703 0-1.25-.547-1.25-1.25V13c0-.664.547-1.25 1.25-1.25.664 0 1.25.586 1.25 1.25z"
  })));
}
export default SvgLockKeyhole;